export function Loader() {
  return (
    <div className="ap:w-xl ap:h-xl ap:rounded-full ap:border-2 ap:border-stroke-accent ap:border-t-stroke-primary ap:animate-spin" />
  )
}
